var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SoundfontFileBoxAdapter_context, _SoundfontFileBoxAdapter_box;
export class SoundfontFileBoxAdapter {
    constructor(context, box) {
        _SoundfontFileBoxAdapter_context.set(this, void 0);
        _SoundfontFileBoxAdapter_box.set(this, void 0);
        __classPrivateFieldSet(this, _SoundfontFileBoxAdapter_context, context, "f");
        __classPrivateFieldSet(this, _SoundfontFileBoxAdapter_box, box, "f");
    }
    get box() { return __classPrivateFieldGet(this, _SoundfontFileBoxAdapter_box, "f"); }
    get uuid() { return __classPrivateFieldGet(this, _SoundfontFileBoxAdapter_box, "f").address.uuid; }
    get address() { return __classPrivateFieldGet(this, _SoundfontFileBoxAdapter_box, "f").address; }
    get soundfont() { return this.getOrCreateLoader().soundfont; }
    getOrCreateLoader() {
        return __classPrivateFieldGet(this, _SoundfontFileBoxAdapter_context, "f").soundfontManager.getOrCreate(__classPrivateFieldGet(this, _SoundfontFileBoxAdapter_box, "f").address.uuid);
    }
    terminate() { }
}
_SoundfontFileBoxAdapter_context = new WeakMap(), _SoundfontFileBoxAdapter_box = new WeakMap();
